import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function Profile() {
    const { user, refreshUser } = useAuth();
    const [form, setForm] = useState({
        name: user?.name || "",
        university: user?.university || "",
        major: user?.major || "",
        graduation_year: user?.graduation_year || "",
        bio: user?.bio || "",
    });
    const [saving, setSaving] = useState(false);

    const save = async () => {
        setSaving(true);
        try {
            await api.patch("/auth/profile", { ...form, graduation_year: form.graduation_year ? parseInt(form.graduation_year) : null });
            await refreshUser();
            toast.success("Profile saved");
        } catch { toast.error("Save failed"); }
        finally { setSaving(false); }
    };

    return (
        <div className="max-w-2xl space-y-8" data-testid="profile-page">
            <header>
                <div className="mono-label">Profile</div>
                <h1 className="font-display text-4xl font-medium tracking-tight mt-2">Your student card</h1>
            </header>

            <div className="flex items-center gap-5 bg-card rounded-2xl border border-border/60 p-6">
                <div className="w-20 h-20 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center font-display text-3xl font-medium">
                    {(user?.name || "S")[0]?.toUpperCase()}
                </div>
                <div>
                    <div className="font-display text-xl font-medium">{user?.name}</div>
                    <div className="text-sm text-muted-foreground">{user?.email}</div>
                    <div className="text-xs text-muted-foreground mt-1">{user?.university || "—"} · {user?.major || "—"}</div>
                </div>
            </div>

            <div className="bg-card rounded-2xl border border-border/60 p-6 space-y-4">
                <div><Label className="mono-label text-xs">Name</Label><Input data-testid="profile-name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="mt-1.5" /></div>
                <div className="grid grid-cols-2 gap-3">
                    <div><Label className="mono-label text-xs">University</Label><Input value={form.university} onChange={e => setForm({ ...form, university: e.target.value })} className="mt-1.5" /></div>
                    <div><Label className="mono-label text-xs">Major</Label><Input value={form.major} onChange={e => setForm({ ...form, major: e.target.value })} className="mt-1.5" /></div>
                </div>
                <div><Label className="mono-label text-xs">Graduation year</Label><Input type="number" value={form.graduation_year} onChange={e => setForm({ ...form, graduation_year: e.target.value })} className="mt-1.5" placeholder="2027" /></div>
                <div><Label className="mono-label text-xs">Bio</Label><Textarea value={form.bio} onChange={e => setForm({ ...form, bio: e.target.value })} className="mt-1.5" rows={3} /></div>
                <div className="flex justify-end pt-2">
                    <Button onClick={save} disabled={saving} data-testid="save-profile">{saving ? "Saving…" : "Save changes"}</Button>
                </div>
            </div>
        </div>
    );
}
